import { APK_HIDING_METHOD_LABELS } from '@crave/config/apk-hiding';
import { cn } from '@/lib/utils';
import { EyeOff, Lock } from 'lucide-react';

const FULL_HIDING_DESCRIPTION =
	'Иконка скрывается из лаунчера и доступна только в настройках приложения.';

type ApkHidingSectionProps = {
	disabled?: boolean;
};

export default function ApkHidingSection({ disabled }: ApkHidingSectionProps) {
	return (
		<div className='flex flex-col gap-3'>
			<div className='flex items-center justify-between gap-2'>
				<h3 className='text-sm font-medium'>Скрытие иконки</h3>
				<span className='inline-flex items-center gap-1 rounded-full border border-primary/20 bg-primary/10 px-2.5 py-0.5 text-[11px] font-medium text-primary'>
					<Lock className='size-3 shrink-0' aria-hidden />
					Всегда включено
				</span>
			</div>

			<div
				className={cn(
					'relative overflow-hidden rounded-xl border border-primary/25 bg-gradient-to-br from-primary/5 via-muted/30 to-muted/10 p-4 ring-1 ring-primary/10',
					disabled && 'opacity-60',
				)}
				aria-disabled={disabled}
			>
				<div className='pointer-events-none absolute -right-6 -top-6 size-24 rounded-full bg-primary/5 blur-2xl' />

				<div className='relative flex gap-3'>
					<div className='flex size-11 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary'>
						<EyeOff className='size-5' aria-hidden />
					</div>
					<div className='flex min-w-0 flex-col gap-1'>
						<p className='text-sm font-semibold leading-tight'>{APK_HIDING_METHOD_LABELS.full}</p>
						<p className='text-xs leading-relaxed text-muted-foreground'>{FULL_HIDING_DESCRIPTION}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
